export default __webpack_public_path__ + "static/index-header-img-sm-ru-46506ae201a5e577df20ef6cc6bd7d25.webp";